import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { Multilingual, TextInput, LongTextInput, NumberInput, CheckBox, DropdownSelector } from 'hyperdb-utils';
import { ModalCreateOwner, ModalCreateGroup } from '../components';
import ZonesAreasSelector from '../components/PropertyEditor/ZonesAreasSelector';
import { AVAILABLE_COUNTRIES } from '../../../../../config';

const MultilingualLongTextInput = Multilingual(LongTextInput);

class CreateForm extends React.Component {
  constructor(props) {
    super(props);
    this.toggleModalCreateOwner = this.toggleModalCreateOwner.bind(this);
    this.handleOwnerCreated = this.handleOwnerCreated.bind(this);
    this.toggleModalCreateGroup = this.toggleModalCreateGroup.bind(this);
    this.handleGroupCreated = this.handleGroupCreated.bind(this);
  }
  componentDidMount() {
    this.fetchGroups();
    this.fetchOwners();
    const clientId = JSON.parse(localStorage.getItem('currentUser')).client_id;
    const availableCountries = clientId === '3912abc1' || clientId === '12345678' ? ['ES'] : ['ID']; //TODO
    this.props.api.country.getObjects({
      propName: 'property_countries',
      queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: {'alpha_2': {in: availableCountries}} }],
    });
  }
  render() {
    const groups = this.props.api.getState('propertyGroup').property_groups;
    const owners = this.props.api.getState('owner').property_owners;
    const countries = this.props.api.getState('country').property_countries;
    const zones = this.props.api.getState('zone').property_zones;
    const areas = this.props.api.getState('area').property_areas;
    return (
      <fieldset>
        <TextInput
          label="Name"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <CheckBox
          label="Daily rental"
          name="daily_rental"
          checked={ this.props.objectData.daily_rental }
          onChange={ this.handleClickCheckbox.bind(this, 'daily_rental') }
        />
        <CheckBox
          label="Monthly rental"
          name="monthly_rental"
          checked={ this.props.objectData.monthly_rental }
          onChange={ this.handleClickCheckbox.bind(this, 'monthly_rental') }
        />
        <TextInput
          label="Code"
          name="code"
          value={ this.props.objectData.code }
          onChange={ this.handleChange.bind(this, 'code') }
        />
        <DropdownSelector
          label={
            <span>
              Group
              &nbsp;<button type="button" className="btn btn-xs btn-primary" onClick={ this.toggleModalCreateGroup.bind(this, true) }>New</button>
            </span>
          }
          name="group"
          value={ this.props.objectData.group.value[1] || '' }
          options={ groupsOptions(groups) }
          onChange={ this.handleChangeRelation.bind(this, 'group') }
        />
        <DropdownSelector
          label={
            <span>
              Owner
              &nbsp;<button type="button" className="btn btn-xs btn-primary" onClick={ this.toggleModalCreateOwner.bind(this, true) }>New</button>
            </span>
          }
          name="owner"
          value={ this.props.objectData.owner.value[1] || '' }
          options={ ownersOptions(owners) }
          onChange={ this.handleChangeRelation.bind(this, 'owner') }
        />
        <DropdownSelector
          label="Type"
          name="type"
          value={ this.props.objectData.type || '' }
          options={ typesOptions() }
          onChange={ this.handleChange.bind(this, 'type') }
        />
        <NumberInput
          label="Surface"
          name="surface"
          value={ this.props.objectData.surface }
          onChange={ this.handleChange.bind(this, 'surface') }
        />
        <NumberInput
          label="Standard Capacity"
          name="standard_capacity"
          value={ this.props.objectData.standard_capacity }
          onChange={ this.handleChange.bind(this, 'standard_capacity') }
        />
        <NumberInput
          label="Maximum Capacity"
          name="maximum_capacity"
          value={ this.props.objectData.maximum_capacity }
          onChange={ this.handleChange.bind(this, 'maximum_capacity') }
        />
        <NumberInput
          label="Nb bedrooms"
          name="nb_bedrooms"
          value={ this.props.objectData.nb_bedrooms }
          onChange={ this.handleChange.bind(this, 'nb_bedrooms') }
        />
        <NumberInput
          label="Nb bathrooms"
          name="nb_bathrooms"
          value={ this.props.objectData.nb_bathrooms }
          onChange={ this.handleChange.bind(this, 'nb_bathrooms') }
        />
        <ZonesAreasSelector
          objectData={ this.props.objectData }
          countries={ countries }
          zones={ zones }
          areas={ areas }
          defaultLanguage={ this.props.defaultLanguage }
          onChange={ this.handleChangeLocation.bind(this) }
        />
        <DropdownSelector
          label="Multi-unit mode"
          name="multi_unit"
          value={ parseInt(this.props.objectData.multi_unit || 0) }
          options={ unitTypeOptions() }
          onChange={ this.handleChange.bind(this, 'multi_unit') }
        />
        {
          parseInt(this.props.objectData.multi_unit) === 1
            ? <NumberInput
                label="Nb units"
                name="nb_units"
                value={ this.props.objectData.nb_units }
                onChange={ this.handleChange.bind(this, 'nb_units') }
              />
            : null
        }
        {
          this.props.showModalOwner
            ? <ModalCreateOwner onClose={ this.toggleModalCreateOwner.bind(this, false) } onOwnerCreated={ this.handleOwnerCreated } />
            : null
        }
        {
          this.props.showModalGroup
            ? <ModalCreateGroup onClose={ this.toggleModalCreateGroup.bind(this, false) } onGroupCreated={ this.handleGroupCreated } />
            : null
        }
      </fieldset>
    );
  }

  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.api.property.updateEditedObject({ attributeName, value });
  }
  handleChangeRelation(attributeName, field) {
    const { name, value } = field;
    const reference = { ...this.props.objectData[attributeName] };
    reference.value[1] = value;
    this.props.api.property.updateEditedObject({ attributeName, value: reference });
    if (attributeName === 'country') {
      this.handleChangeRelation('zone', { value: null });
      if (value) this.findZones(value);
    }
    if (attributeName === 'zone') {
      this.handleChange('areas', { value: [] });
      if (value) this.findAreas(value);
    }
  }
  handleChangeLocation(attributeName, field) {
    if (attributeName === 'areas') return this.handleChange('areas', field);
    this.handleChangeRelation(attributeName, field);
  }
  handleClickCheckbox(attributeName) {
    const value = !this.props.objectData[attributeName];
    this.props.api.property.updateEditedObject({ attributeName, value });
  }

  fetchGroups() {
    this.props.api.propertyGroup.getObjects({
      propName: 'property_groups',
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  fetchOwners() {
    this.props.api.owner.getObjects({
      propName: 'property_owners',
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
  }
  findZones(countryId) {
    this.props.api.zone.getObjects({
      propName: 'property_zones',
      queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { 'country.id': countryId } }],
    });
  }
  findAreas(zoneId) {
    this.props.api.area.getObjects({
      propName: 'property_areas',
      queryOptions: [['id', 'name'], { order: { name: 'asc' }, where: { 'zone.id': zoneId } }],
    });
  }

  toggleModalCreateGroup(bool) {
    this.props.api.property.setData({ showModalGroup: bool });
  }
  handleGroupCreated(groupId) {
    this.fetchGroups();
    this.handleChangeRelation('group', { value: groupId });
    this.toggleModalCreateGroup(false);
  }
  toggleModalCreateOwner(bool) {
    this.props.api.property.setData({ showModalOwner: bool });
  }
  handleOwnerCreated(ownerId) {
    this.fetchOwners();
    this.handleChangeRelation('owner', { value: ownerId });
    this.toggleModalCreateOwner(false);
  }
}

function typesOptions() {
  return ['house', 'villa', 'apartment', 'room', 'bingalow', 'mobil-home', 'castle', 'shop', 'office', 'warehouse', 'other' ].map(t => {
    return { name: t, value: t };
  });
}
function ownersOptions(owners) {
  if (!owners) return [];
  return owners.map(owner => {
    return { name: owner.name, value: owner.id };
  });
}
function groupsOptions(groups) {
  if (!groups) return [];
  return groups.map(group => {
    return { name: group.name, value: group.id };
  });
}
function unitTypeOptions() {
  return [
    { name: 'single unit', value: 0 },
    { name: 'multiple units', value: 1 },
    { name: 'independent units', value: 2 },
  ];
}

CreateForm.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  defaultLanguage: React.PropTypes.string,
};

export default HyperdbForm(CreateForm, {
  namespace: 'property',
  mountedUrl: '/properties',
  titleNew: 'Create new property',
  asWizardForCreate: true,
  afterCreate: (props) => props.api.routing.redirect(props.router, `/properties/${props.savedObject.id}`),
  checkIsValid: (props) => !!props.objectData.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/containers/CreateForm.jsx